import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';
import { APP_VERSION_HEADER_NAME } from '../constants';

export function responseHeaderVersionDiffers(
  headers: RawAxiosResponseHeaders | AxiosResponseHeaders,
) {
  const differs =
    headers[APP_VERSION_HEADER_NAME] &&
    headers[APP_VERSION_HEADER_NAME] !== process.env.VITE_AZDO_BUILD_NUMBER;

  if (differs) {
    console.log(
      'Server response version does not match loaded app version.',
      headers[APP_VERSION_HEADER_NAME],
      process.env.VITE_AZDO_BUILD_NUMBER,
    );
  }

  return differs;
}
